import {IEnvironment} from '../app/0-application/types'

export const environment: IEnvironment = {
  production: false,
  domain: 'payment-validation-stage.internal.sparbankensyd.se',
  authServiceUrl: 'https://pv-test.internal.sparbankensyd.se/service',
  //apiUrl: 'https://pv-test.internal.sparbankensyd.se/api'
  // Fix when CF is ready
  apiUrl: 'https://api-payment-xml-be-test.internal.sparbankensyd.se/api'
}